// extracted by mini-css-extract-plugin
export var formContainer = "_cw-0";
export var message = "_cw-1";